import axios from 'axios'
import store from '../index'
import router from '../../router'
import auth0 from "../../auth0-client";

const API_CONSTANTS = {
  SERVER: process.env.VUE_APP_API_URL
}

const axiosInstance = axios.create({
  baseURL: API_CONSTANTS.SERVER
})

axiosInstance.interceptors.request.use(async function(config) {
  const {headers} = config;
  headers['Content-Type'] = 'application/json';
  const token = await auth0.getAccessToken();
  // console.log("sign-in token", token);
  // const {token} = store.state
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  config.timeout = 4000
  return config
})

axiosInstance.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.status === 403) {
    store.dispatch('logOut')
      .then(() => router.push('/auth'))
      .catch(err => console.error(err))
  }
  return Promise.reject(error)
})

export const signIn = async (email, password) => {
  const {data} = await axiosInstance.post(`/signin/`, {username: email, password})
  return data
}
export const signUp = async (email, password) => {
  const {data: {username}} = await axiosInstance.post(`/signup/`, {username: email, password})
  const {data} = await axiosInstance.post(`/signin/`, {username, password})
  return data
}

export const getProfile = async () => {
  const {data} = await axiosInstance.get(`/profile/`)
  return data
}
export const saveProfile = async (profile) => {
  await axiosInstance.put(`/profile/`, profile)
}
export const getConfig = async () => {
  const {data} = await axiosInstance.get(`/config/`)
  return data
}
export const saveConfig = async (config) => {
  await axiosInstance.put(`/config/`, {...config})
}
export const getLicense = async () => {
  try {
    const {data} = await axiosInstance.get(`/license/`)
    return data
  } catch (e) {
    if (e.response && e.response.status === 400) {
      if (e.response.data && e.response.data.msg) {
        throw new Error(e.response.data.msg)
      }
      return null
    }
    throw e
  }
}
export const getTrial = async () => {
  try {
    const {data} = await axiosInstance.get(`/trial-license/`)
    return data
  } catch (e) {
    if (e.response && e.response.status === 400) {
      if (e.response.data && e.response.data.msg) {
        throw new Error(e.response.data.msg)
      }
      return null
    }
    throw e
  }
}
export const buyLicense = async () => {
  try {
    const {data: {msg}} = await axiosInstance.get(`/request-license/`)
    return msg
  } catch (e) {
    console.log(e.response)
    if (e.response && e.response.status === 400) {
      throw new Error(e.response.data.msg)
    }
    throw new Error('server error')
  }
}
export const requestResetPassword = async (email) => {
  try {
    const {data} = await axiosInstance.post(`/password-reset/`, {email})
    return data
  } catch (e) {
    const message = e.response ? e.response.data.msg : e.message
    throw new Error(message)
  }
}
export const confirmResetPassword = async (token, password) => {
  try {
    const {data} = await axiosInstance.put(`/password-reset/`, {token, password})
    return data
  } catch (e) {
    const message = e.response ? e.response.data.msg : e.message
    throw new Error(message)
  }
}
